export default "__VITE_ASSET__C2bXCh9z__"